
import { Label } from "@/components/ui/label";

export type DownloadFormat = "pdf" | "docx";

interface FormatSelectorProps {
  downloadFormat: DownloadFormat;
  onFormatChange: (format: DownloadFormat) => void;
}

export function FormatSelector({ downloadFormat, onFormatChange }: FormatSelectorProps) {
  return (
    <div className="space-y-2">
      <Label>Download Format</Label>
      <div className="flex space-x-4">
        <div className="flex items-center space-x-2">
          <input
            type="radio"
            id="pdf"
            value="pdf"
            checked={downloadFormat === "pdf"}
            onChange={(e) => onFormatChange(e.target.value as DownloadFormat)}
            className="h-4 w-4"
          />
          <Label htmlFor="pdf">PDF</Label>
        </div>
        <div className="flex items-center space-x-2">
          <input
            type="radio"
            id="docx"
            value="docx"
            checked={downloadFormat === "docx"}
            onChange={(e) => onFormatChange(e.target.value as DownloadFormat)}
            className="h-4 w-4"
          />
          <Label htmlFor="docx">DOCX</Label>
        </div>
      </div>
    </div>
  );
}
